import script from "./NavbarLink.vue?vue&type=script&setup=true&lang=ts"
export * from "./NavbarLink.vue?vue&type=script&setup=true&lang=ts"

import "./NavbarLink.vue?vue&type=style&index=0&id=4ebcb740&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ebcb740"]])

export default __exports__